module.exports = __webpack_public_path__ + "static/img/e201.9ff73d98.png";